import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const recruiterInvitation = {
    mobile: {
        header: {
            height: "29.46vw",
            background: Color.DeepBlack,
            backgroundSvg: {
                position: "absolute",
                width: "61.3vw",
                height: "34.3vw",
                top: "52",
                right: "0",
                zIndex: 0
            },
            heading: {
                position: "absolute",
                color: Color.White,
                width: "100%",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "6.03vw",
                marginTop: "10.47vw",
                marginBottom: "auto"
            }
        },
        divider: {
            border: "none",
            height: "0.3vw",
            backgroundColor: Color.MiddleAsh,
            margin: "0",
            position: "relative",
            zIndex: 1
        },
        container: {
            margin: "4.83vh auto 11.16vh auto",
            textAlign: "center" as "center"
        },
        image: {
            width: "73.93vw",
            height: "58.22vw",
            marginTop: "6.2vw",
            marginBottom: "10vw"
        },
        invalidTitle: {
            fontWeight: "bold" as "bold",
            fontSize: "6.03vw",
            color: Color.LightBlack,
            margin: "0 auto 7.25vw"
        },
        buttonsContainer: {
            display: "block",
            justifyContent: "center",
            marginBottom: "24.1vw"
        },
        button: {
            border: "none",
            backgroundColor: Color.Green,
            color: Color.White,
            borderRadius: "2.41vw",
            width: "90vw",
            height: "12.07vw",
            padding: "1.67vh",
            fontSize: "4.35vw",
            fontWeight: "bold" as "bold",
            boxShadow: "2.42vw 2.42vw 6.04vw #00000029",
            marginTop: "1.52vh",
            back: {
                backgroundColor: Color.Blue,
                marginLeft: "0",
                boxShadow: "none"
            }
        },
        submitButton: {
            border: "none",
            backgroundColor: Color.Green,
            color: Color.White,
            width: "80vw",
            height: "12.08vw",
            borderRadius: "2.41vw",
            fontSize: "4.34vw",
            fontFamily: Font.Default,
            fontWeight: "bold" as "bold",
            textTransform: "uppercase",
            boxShadow: "5px 5px 50px #00000027",
            cursor: "pointer",
            marginTop: "3vw",
            loading: {
                opacity: 0.6,
                cursor: "not-allowed"
            }
        },
        formContainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "80%",
            margin: "6vw auto 8vw auto"
        },
        inputWrapper: {
            width: "100%",
            marginBottom: "3vw"
        },
        inputLabel:{
            fontFamily: "Poppins",
            fontSize: "3.86vw",
            color: Color.DeepAsh,
            marginBottom: "1.2077vw",
            marginTop: "4.83vw"
        },
        nameWrapper: {
            width: "100%",
        },
        textInput: {
            height: "12.07vw",
            fontSize: "3.86vw",
            marginTop: "0.80vw",
            borderRadius: "1.20vw"
        },
    },
    desktop: {
        header: {
            height: "13.58vw",
            backgroundSvg: {
                marginTop: "-6.5vw",
                width: "100%",
                height: "24.145vw",
                top: "none",
                right: "0",
            },
            heading: {
                fontSize: "2.6vw",
                marginTop: "2.37vw"
            }
        },
        divider: {
            display: "none"
        },
        container: {
            width: "43.85vw",
            margin: "0 auto 13.88vh auto"
        },
        image: {
            width: "20vw",
            height: "15.75vw",
            marginTop: "2.5vw",
            marginBottom: "1.6vw"
        },
        invalidTitle: {
            fontSize: "1.56vw",
            margin: "0 auto 1.41vw"
        },
        buttonsContainer: {
            marginBottom: "7.81vw"
        },
        button: {
            width: "18.125vw",
            height: "3.64vw",
            fontSize: "1.04vw",
            padding: "2.12vh",
            borderRadius: "0.52vw",
            boxShadow: "0.52vw 0.52vw 1.30vw #00000029",
            back: {
                marginLeft: "0.78vw"
            }
        },
        formContainer: {
            display: "flex",
            flexDirection: "column",
            width: "50%",
            margin: "3vw auto 3vw auto"
        },
        inputWrapper: {
            width: "100%",
            marginBottom: "1.04vw"
        },
        inputLabel:{
            fontSize: "0.9375vw",
            marginBottom: "0.52vw",
            marginTop: "1.04vw"
        },
        nameWrapper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "1.04vw"
        },
        submitButton: {
            height: "3.64vw",
            width: "20vw",
            borderRadius: "0.52vw",
            fontSize: "1.04vw",
            marginTop: "1.3vw"
        },
        textInput: {
            height: "3.125vw",
            fontSize: "0.9375vw",
            marginTop: "0.26vw",
            borderRadius: "0.52vw"
        }
    }
};
